<!--
 * @Desc: 菜单
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-06 10:03:17
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <ul class="menu-vertical">
        <li
            class="menu-vertical-item"
            v-for="(item,idx) in menuList"
            :key="idx"
            @click="navClick(item)"
            :class="[active == item.id ? 'active' : '']"
        >
        {{ item.name }}
        </li>
    </ul>
</template>
<script>
import calendarFormatter from "@/api/dateChange";
export default {
    data() {
        return {
            menuList:[],//菜单列表
        };
    },
    props: {
        // 菜单选中，
        active: {
            type: String,
            default: function () {
                return '';
            },
        },
    },
    computed: {},
    // watch:{
    //     $route(val){
    //         this.pageChange(val.name);
    //     }
    // },
    created: function () {
        let that = this;
        if (that.Cookies.get("menuList")){
            that.menuList = JSON.parse(that.Cookies.get("menuList"))
        } else {
            let timerMenu = setInterval(function(){
                that.menuList = JSON.parse(that.Cookies.get("menuList"))
                if (that.Cookies.get("menuList")) {
                    clearInterval(timerMenu)
                }
            },1000)
        }
    },
    methods: {
        /**
         * @name: 菜单点击
         * @return {*}
         * @desc: 菜单点击
         */
        navClick(item) {
            this.$toPath(item.url, {
                active:item.id
            });
        },
    },
};
</script>

<style scoped>
.menu-vertical{
    width: 154px;
    margin-right: 16px;
}
.menu-vertical .menu-vertical-item{
    cursor: pointer;
    width: 154px;
    height: 55px;
    background: rgba(255, 255, 255, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
}
.menu-vertical .menu-vertical-item:hover{
    color: rgba(226, 47, 36, 1);
    box-shadow: 0px 12px 14px 0px rgba(238, 238, 238, 1);
    z-index: 2;
}
.menu-vertical .menu-vertical-item.active{
    color: rgba(226, 47, 36, 1);
    box-shadow: 0px 12px 14px 0px rgba(238, 238, 238, 1);
    z-index: 2;
}
</style>
